/**
 * Checks if a token (e.g. membership tokens) contains only alphabetic characters and dashes.
 *
 * This validation ensures the string contains only uppercase and/or lowercase
 * letters (A–Z, a–z) and hyphens (-). It does not allow numbers, underscores,
 * spaces, or any other special characters.
 *
 * @param {string} token - The string to validate.
 * @returns {boolean} True if the token contains only letters and dashes; otherwise, false.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();export const isAlphaOnly = (token: string): boolean => {
  const regex = /^[a-zA-Z-]+$/;
  return regex.test(token);
}
  